// libs
import { connect } from 'react-redux';
import get from 'lodash/get';

// components
import WithConfig from './WithConfig';

// selectors
import { getResponsibleTags } from 'shared/store/details/selectors';
import { getRemoteConfig } from 'shared/store/remoteConfigs/selectors';

const mapStateToProps = (state: any) => {
  return {
    widget: getResponsibleTags(state),
    responsibleTagsEnabled: get(getRemoteConfig(state, 'PDPResponsibleTags'), 'enabled', true),
  };
};

export default connect(mapStateToProps)(WithConfig);
